import { render, staticRenderFns } from "./LeftWrap1.vue?vue&type=template&id=cca774cc&scoped=true"
import script from "./LeftWrap1.vue?vue&type=script&lang=js"
export * from "./LeftWrap1.vue?vue&type=script&lang=js"
import style0 from "./LeftWrap1.vue?vue&type=style&index=0&id=cca774cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca774cc",
  null
  
)

export default component.exports